import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllAmountUnits, getSymbolGroup, getAllSymbolParameters, getSymbol } from "../../api/request/dashboard/dashboard";
import { setSymbolsData } from "../Slices/watchList";
import { queryClient } from "../..";

export const fetchSymbolGroup = createAsyncThunk('symbolGroup/get', async () => {
    try {
        const { data } = await getSymbolGroup();
        return data;
    } catch (err) {
        return [];
    }
})

export const fetchAmountUnit = createAsyncThunk('amountUnit/get', async () => {
    try {
        const { data } = await getAllAmountUnits();
        console.log("🚀 Amount units from API:", data); 

        return data;
    } catch (err) {
        return [];
    }
})

export const fetchAllSymbolParams = createAsyncThunk('allSymbolParameter/get', async (_, { getState, dispatch }) => {
    try {
        const clientId = getState().user?.userDetail?.id;
        if (!clientId) throw new Error('Invalid clientId');

        // const { symbols } = getState().watchlist;
        const { data } = await getAllSymbolParameters(clientId);
        const { data: rowSymbols } = await getSymbol(clientId)

        const symbols = {}
        rowSymbols?.forEach((update) => {
            symbols[update?.id] = { ...update };
        });
        const objData = {};
        data?.forEach(item => {
            objData[item.symbolId] = {
                ...objData[item.symbolId],
                ...item
            };
        });
        dispatch(setSymbolsData(symbols));
        
        return objData;
    } catch (err) {
        console.error('Failed to fetch symbol params:', err);
        return {};
    }
});
